<script lang="ts">
  // TODO: Convert to chart.js svelte 5

  import {
    Chart,
    Title,
    Tooltip,
    Legend,
    BarElement,
    CategoryScale,
    LinearScale
  } from "chart.js"

  let props = $props()
  let { pre_data = [], post_data = [] }: { pre_data: any[]; post_data: any[] } =
    props

  const data = {
    labels: ["Brand Purpose", "Values", "Vision", "Top 3 Goals"],

    datasets: [
      {
        label: "Pre-Alignment",
        data: pre_data,
        backgroundColor: [
          "rgba(255,134,159,0.4)",
          "rgba(255,134,159,0.4)",
          "rgba(255,134,159,0.4)",
          "rgba(255,134,159,0.4)"
        ],
        borderWidth: 2,
        borderColor: [
          "rgba(255,134,159,1)",
          "rgba(255,134,159,1)",
          "rgba(255,134,159,1)",
          "rgba(255,134,159,1)"
        ]
      },
      {
        label: "Post-Alignment",
        data: post_data,
        backgroundColor: [
          "rgba(54,162,235,0.4)",
          "rgba(54,162,235,0.4)",
          "rgba(54,162,235,0.4)",
          "rgba(54,162,235,0.4)"
        ],
        borderWidth: 2,
        borderColor: [
          "rgba(54,162,235,1)",
          "rgba(54,162,235,1)",
          "rgba(54,162,235,1)",
          "rgba(54,162,235,1)"
        ]
      }
    ]
  }

  const options = {
    scales: {
      y: {
        min: 0,
        max: 100,
        ticks: {
          stepSize: 20
        },
        title: {
          display: true,
          text: "% Aligned"
        }
      }
    },
    responsive: true
  }
  Chart.register(Title, Tooltip, Legend, BarElement, CategoryScale, LinearScale)
</script>

<!-- <Bar {data} {options} /> -->
